import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationExportsPage } from "~/pages/settings/organisations/organisation/exports/organisation-exports-page";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/exports/",
)({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.exports") }] }),
  component: OrganisationExportsPage,
});
